module.exports = __webpack_public_path__ + "static/media/canada6.6a88d049.jpg";